// Shopify Product ID Mapping
// Maps our internal product IDs to Shopify product IDs and variant IDs

export const shopifyProductMap = {
  // TCV Series - Thumb Click Vials
  'TCV-13': { 
    productId: '7851490967661',
    variantId: '43565794197613'  // 13 Dram - $35.40
  },
  'TCV-16': { 
    productId: '7851490967661',
    variantId: '43565795049581'  // 16 Dram - $32.30
  },
  
  // CR Series - Child Resistant Vials
  'CR-06': { 
    productId: '7851497455725',
    variantId: '43565804552301'  // 6 Dram - $55.86
  },
  'CR-08': { 
    productId: '7851497455725',
    variantId: '43565804585069'  // 8 Dram - $40.72
  },
  'CR-13': { 
    productId: '7851497455725',
    variantId: '43565804617837'  // 13 Dram - $45.80
  },
  'CR-20': { 
    productId: '7851497455725',
    variantId: '43565804650605'  // 20 Dram - $55.11
  },
  
  // RCV Series - Reversible Cap Vials
  'RCV-08': { 
    productId: '7851484774509',
    variantId: '43565769359469'  // 8 Dram - $45.86
  },
  'RCV-13': { 
    productId: '7851484774509',
    variantId: '43565769392237'  // 13 Dram - $43.31
  },
  'RCV-20': { 
    productId: '7851484774509',
    variantId: '43565769425005'  // 20 Dram - $46.90
  },
  
  // OJ Series - Ointment Jars
  'OJ-100': { 
    productId: '7851510890605',
    variantId: '43565853933677'  // 8 oz - $34.11
  },
  'OJ-400': { 
    productId: '7851510890605',
    variantId: '43565853966445'  // 16 oz - $45.25
  }
};

// Helper function to check if product has Shopify integration
export const hasShopifyIntegration = (productId) => {
  return productId in shopifyProductMap;
};

// Helper function to get Shopify product ID
export const getShopifyProductId = (productId) => {
  return shopifyProductMap[productId]?.productId || null;
};

// Helper function to get Shopify variant ID
export const getShopifyVariantId = (productId) => {
  return shopifyProductMap[productId]?.variantId || null;
};
